import React from 'react';
import PropTypes from 'prop-types';

import makeStyles from '@mui/styles/makeStyles';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';

import Typography from '@ts-core/components/Typography';

import CourseCard from '@ts-core/components/CourseCard';

const useStyles = makeStyles((theme) => ({
  root: {
    '&:not(:last-child)': {
      borderBottom: 'solid 1px rgba(0, 0, 0, 0.12)',
    },
    '&:not(:first-child)': {
      paddingTop: theme.spacing(4),
    },
  },
}));

const CourseListSection = (props) => {
  const {
    section,
    loading,
    onSelectCourse,
    onEditCourse,
    onRemoveCourse,
  } = props;
  const { courses: sCourses = [], title } = section;
  const courses = loading ? Array.from(new Array(2)) : sCourses;
  const classes = useStyles();

  return (
    <Box pb={4} className={classes.root}>
      <Box pb={2}>
        <Typography
          variant="h6"
          loading={loading}
          skeletonWidth={200}
          skeletonHeight={44}
        >
          {title}
        </Typography>
      </Box>
      <Grid
        container
        spacing={3}
        direction="row"
        className={classes.bottomPadding}
      >
        {courses.map((course, index) => (
          <Grid item xs={12} sm={6} md={3} lg={3} key={index}>
            <CourseCard
              loading={loading}
              course={course}
              onSelectCourse={onSelectCourse}
              onEditCourse={onEditCourse}
              onRemoveCourse={onRemoveCourse}
            />
          </Grid>
        ))}
        {/* {courses.length === 0 && !loading && (
          <Grid item xs={12} sm={6} md={4} lg={3}>
            <AddEntityCard
              onAdd={handleAddCourse}
              message={<FormattedMessage id="addFirstCourseCard.title" />}
            />
          </Grid>
        )} */}
      </Grid>
    </Box>
  );
};

CourseListSection.propTypes = {
  loading: PropTypes.bool,
  section: PropTypes.shape({
    title: PropTypes.string,
    courses: PropTypes.array,
  }),
  onSelectCourse: PropTypes.func.isRequired,
  onRemoveCourse: PropTypes.func,
  onEditCourse: PropTypes.func,
};

CourseListSection.defaultProps = {
  loading: false,
  section: {},
  onRemoveCourse: undefined,
  onEditCourse: undefined,
};

export default CourseListSection;
